import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { StoreDataProvider } from "@/context/StoreDataContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WhatsAppButton from "@/components/WhatsAppButton";
import WelcomePopup from "@/components/WelcomePopup";

function StoreLayout({ children }) {
    return (
        <>
            <Header />
            <main className="min-h-[60vh]">{children}</main>
            <Footer />
        </>
    );
}

function Shell() {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");
    return (
        <>
            {isAdmin ? (
                <Routes>
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
            ) : (
                <StoreLayout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/catalogo" element={<Catalog />} />
                        <Route path="/producto/:id" element={<ProductDetail />} />
                        <Route path="/carrito" element={<Cart />} />
                        <Route path="/checkout" element={<Checkout />} />
                        <Route path="/pedido-confirmado/:orderId" element={<OrderSuccess />} />
                    </Routes>
                    <WhatsAppButton />
                    <WelcomePopup />
                </StoreLayout>
            )}
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <StoreDataProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Shell />
                        <Toaster
                            position="top-right"
                            toastOptions={{
                                style: {
                                    fontFamily: "Manrope, sans-serif",
                                    borderRadius: "10px",
                                    border: "1px solid #E8DCC8",
                                },
                            }}
                        />
                    </BrowserRouter>
                </CartProvider>
            </StoreDataProvider>
        </div>
    );
}
